import type { ReactNode } from 'react'
import { UserhubProvider } from '@userhub/widget'
import { APP_VERSION } from '../lib/version'
import { useLang } from '../i18n'
import { getUserhubToken } from '../lib/auth'
import { USERHUB_API_BASE_URL } from './config'
import { useUserhubTheme } from './theme'

/**
 * The userhub feedback service's context, mounted once around the signed-in shell (main.tsx,
 * inside AuthGate). Context only: the provider renders no element and themes nothing of Niobe's —
 * the theme reaches the widget's own Fluent dialogs and nothing else. The trigger is the account
 * menu (components/TopBar.tsx). The widget's own UI follows Niobe's EN/FR toggle (`lang`, widget
 * 0.10.0+); the guided-tour engine (App.tsx) is mounted inside, so it can record completions here.
 *
 * `getUserhubToken` is a module function, so its identity is stable: the provider rebuilds its
 * HTTP client whenever that identity changes.
 */
export function UserhubShell({ children }: { children: ReactNode }) {
  const theme = useUserhubTheme()
  const { lang } = useLang()
  return (
    <UserhubProvider
      application="Niobe"
      appVersion={APP_VERSION}
      apiBaseUrl={USERHUB_API_BASE_URL}
      getAccessToken={getUserhubToken}
      theme={theme}
      lang={lang}
    >
      {children}
    </UserhubProvider>
  )
}
